(ns io.daskul.tutorial.webapp.views.conversation-thread.compose-state
  "Composer reply-gating decision for the conversation thread — pure, no view
   dependencies.

   Extracted from the view namespace (#223) so it can be unit tested. The
   :node-test harness compiles only what is reachable from *-test namespaces,
   precisely to keep React/Mantine/uix out; requiring a view namespace pulls in
   the whole layout stack, which fails to load under Node. So this decision —
   whether a reply can be sent, and which notice to show when it can't — lives
   here where a test can reach it without the layout.")

(defn compose-state
  "Decide the composer's reply-gating state from the conversation record:

     {:can-reply? boolean
      :notice     nil | :no-page | :window-closed}

   Two independent reasons a reply is impossible, in precedence order:
     :no-page       — the conversation's Facebook Page is not active (SMS-57);
                      a reply would 409. Fix the Page first, so this wins.
     :window-closed — the Page is fine but Meta's reply window has closed
                      (#223): no inbound within 7 days, so no standard send is
                      possible.

   While the conversation is still loading (nil), the composer is optimistically
   enabled with no notice — the flags aren't known yet, and asserting a block
   here would flash a notice on every thread open before the first read lands."
  [conversation]
  (if (nil? conversation)
    {:can-reply? true :notice nil}
    (let [page-connected? (:facebook-page-connected? conversation)
          window-closed?  (= "closed" (:reply-window conversation))]
      (cond
        (not page-connected?) {:can-reply? false :notice :no-page}
        window-closed?        {:can-reply? false :notice :window-closed}
        :else                 {:can-reply? true  :notice nil}))))
